const toTanNumber = (num)=>{
    var arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九','十');
    return arr1[num]
}

export default toTanNumber